import { render, staticRenderFns } from "./not-available-in-free.vue?vue&type=template&id=5caa05d2&scoped=true&"
import script from "./not-available-in-free.vue?vue&type=script&lang=js&"
export * from "./not-available-in-free.vue?vue&type=script&lang=js&"
import style0 from "./not-available-in-free.vue?vue&type=style&index=0&id=5caa05d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa05d2",
  null
  
)

export default component.exports